import { Printer, Download, MoreHorizontal, X } from "lucide-react"
import { Button } from "@/components/ui/button"

interface PrescriptionDetailsHeaderProps {
  erxNumber: string
  onClose?: () => void
}

export function PrescriptionDetailsHeader({ erxNumber, onClose }: PrescriptionDetailsHeaderProps) {
  return (
    <div className="flex items-center justify-between pb-2 border-b">
      <div>
        <h2 className="text-base font-semibold">Prescription Info</h2>
        <div className="text-xs text-muted-foreground">eRx No: {erxNumber}</div>
      </div>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Printer className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Download className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
